import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { onMounted } from '@nuxtjs/composition-api'
import { amplitudeLogEvent, amplitudeEvents } from '@shared/lib'
import { OrderItem, useOrderModel } from '@entities/order'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderList',
  props: {
  currencyIcon: {
    type: String as PropType<string>,
    required: false,
    default: ''
  }
},
  setup(__props) {

const props = __props

const orderModel = useOrderModel()



// Выбор позиции
const checkPosition = async (data: any) => {
  await orderModel.selectOrderPosition({
    id: data.id,
    status: data.status,
    guest: data.guest
  })
}

onMounted(() => {
  setTimeout(() => {
    amplitudeLogEvent(amplitudeEvents.ORDER, { ОтображениеЗаказа: 'Есть заказ' })
  }, 3000)
})

return { __sfc: true,orderModel, props, checkPosition, OrderItem }
}

})